import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Header from './Header.vue';
import Sidebar from './sidebar.vue';
import Manage_bar from './manage-bar.vue';
import Index from './index.vue';
import Billofsale from './bill-of-sale.vue';
import Leaseagreement from './lease-agreement.vue';
import Leaseterminationagreement from './lease-termination-agreement.vue';
import Evictionnotice from './eviction-notice.vue';
import Financialpowerofattorney from './financial-power-of-attorney.vue';
import Medicalpowerofattorney from './medical-power-of-attorney.vue';
import Childpowerofattorney from './child-power-of-attorney.vue';
import Revocationpowerofattorney from './revocation-power-of-attorney.vue';
import Lastwillandtestament from './last-will-and-testament.vue';
import Resignationletter from './resignation-letter.vue';
import Recommendationletter from './recommendation-letter.vue';
import Non_disclosure_agreement from './non-disclosure-agreement.vue';
import Llc_operating_agreement from './llc-operating-agreement.vue';
import Ceaseanddesistletter from './cease-and-desist-letter.vue';
import Limitedpowerofattorney from './limited-power-of-attorney.vue';
import Prenuptial_agreement from './prenuptial-agreement.vue';
import Independent_contractor_agreement from './independent-contractor-agreement.vue';
import Divorce_settlement_agreement from './divorce-settlement-agreement.vue';
import Business_contract from './business-contract.vue';
import Employment_contract from './employment-contract.vue';
import Createaccount from './create-account.vue';
import Account_tabs from './account-tabs.vue';
import Account from './account.vue';
import Billing from './billing.vue';
import Edit_billing from './edit-billing.vue';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueCookies);

const routes = [
  { name: 'index' ,path: '/dashboard/', component: Index },
  { name: 'index' ,path: '/dashboard/index', component: Index },
  { name: 'bill-of-sale' ,path: '/dashboard/bill-of-sale', component: Billofsale },
  { name: 'lease-agreement' ,path: '/dashboard/lease-agreement', component: Leaseagreement },
  { name: 'lease-termination-agreement' ,path: '/dashboard/lease-termination-agreement', component: Leaseterminationagreement },
  { name: 'eviction-notice' ,path: '/dashboard/eviction-notice', component: Evictionnotice },
  { name: 'financial-power-of-attorney' ,path: '/dashboard/financial-power-of-attorney', component: Financialpowerofattorney },
  { name: 'medical-power-of-attorney' ,path: '/dashboard/medical-power-of-attorney', component: Medicalpowerofattorney },
  { name: 'child-power-of-attorney' ,path: '/dashboard/child-power-of-attorney', component: Childpowerofattorney },
  { name: 'revocation-power-of-attorney' ,path: '/dashboard/revocation-power-of-attorney', component: Revocationpowerofattorney },
  { name: 'last-will-and-testament' ,path: '/dashboard/last-will-and-testament', component: Lastwillandtestament },
  { name: 'resignation-letter' ,path: '/dashboard/resignation-letter', component: Resignationletter },
  { name: 'recommendation-letter' ,path: '/dashboard/recommendation-letter', component: Recommendationletter },
  { name: 'non-disclosure-agreement' ,path: '/dashboard/non-disclosure-agreement', component: Non_disclosure_agreement },
  { name: 'llc-operating-agreement' ,path: '/dashboard/llc-operating-agreement', component: Llc_operating_agreement },
  { name: 'cease-and-desist-letter' ,path: '/dashboard/cease-and-desist-letter', component: Ceaseanddesistletter },
  { name: 'limited-power-of-attorney' ,path: '/dashboard/limited-power-of-attorney', component: Limitedpowerofattorney },
  { name: 'prenuptial-agreement' ,path: '/dashboard/prenuptial-agreement', component: Prenuptial_agreement },
  { name: 'independent-contractor-agreement' ,path: '/dashboard/independent-contractor-agreement', component: Independent_contractor_agreement },
  { name: 'divorce-settlement-agreement' ,path: '/dashboard/divorce-settlement-agreement', component: Divorce_settlement_agreement },
  { name: 'business-contract' ,path: '/dashboard/business-contract', component: Business_contract },
  { name: 'employment-contract' ,path: '/dashboard/employment-contract', component: Employment_contract },
  { name: 'create-account' ,path: '/dashboard/create-account', component: Createaccount },
  { name: 'account' ,path: '/dashboard/account', component: Account },
  { name: 'billing' ,path: '/dashboard/billing', component: Billing },
  { name: 'edit-billing' ,path: '/dashboard/edit-billing', component: Edit_billing },
];

const router = new VueRouter({
  scrollBehavior() {
  return { x: 0, y: 0 };
},
routes,
mode: 'history'
});

Vue.component('app-header', Header);
Vue.component('sidebar-header', Sidebar);
Vue.component('manage-bar', Manage_bar);
Vue.component('account-header', Account_tabs);
Vue.component('vue-headful', VueHeadful);

var vm  = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js